import GenericConfirmationModal from './generic-confirmation-modal'
import GenericInfoModal from './generic-info-modal'
import SelectOptionModal from './select-option-modal'
import SendTipModal from './send-tip-modal'
import SubscribeModal from './subscribe-modal'
import SubscribeModalPlan from './subscribe-modal-plan'
import FlagContentModal from './flag-content-modal'
import CreatorMentionDropdownModal from './creator-mention-dropdown-modal'
import CreatorsListModal from './creators-list-modal'
import FollowersModal from './followers-modal'
import FollowingsModal from './followings-modal'
import LikesModal from './likes-modal'
import AcceptCookiesModal from './accept-cookies-modal'
import CreateMediaVaultAlbumModal from './create-media-vault-album-modal'
import UpdateMediaVaultAlbumModal from './update-media-vault-album-modal'
import ProfileLeftPanel from './profile-left-panel'
import SelectMediaVaultAlbumModal from './select-media-vault-album-modal'
import SelectMediaVaultFilesModal from './select-media-vault-files-modal'
import LegalLeftPanel from './legal-left-panel'
import GdprRequestModal from './gdpr-request-modal'
import ManageCookiesModal from './manage-cookies-modal'

export default {
    GenericConfirmationModal,
    GenericInfoModal,
    SelectOptionModal,
    SendTipModal,
    SubscribeModal,
    SubscribeModalPlan,
    FlagContentModal,
    CreatorMentionDropdownModal,
    CreatorsListModal,
    FollowersModal,
    FollowingsModal,
    LikesModal,
    AcceptCookiesModal,
    CreateMediaVaultAlbumModal,
    UpdateMediaVaultAlbumModal,
    ProfileLeftPanel,
    SelectMediaVaultAlbumModal,
    SelectMediaVaultFilesModal,
    LegalLeftPanel,
    GdprRequestModal,
    ManageCookiesModal,
}
